import { render, staticRenderFns } from "./ComponentAdminEditPlant.vue?vue&type=template&id=e6abc3e4&scoped=true"
import script from "./ComponentAdminEditPlant.vue?vue&type=script&lang=js"
export * from "./ComponentAdminEditPlant.vue?vue&type=script&lang=js"
import style0 from "./ComponentAdminEditPlant.vue?vue&type=style&index=0&id=e6abc3e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6abc3e4",
  null
  
)

export default component.exports